import JSBI from 'jsbi'
import { Token } from './entities/v2/token'
import { Percent } from './entities/fractions/percent'

export enum ChainId {
  MAINNET = 56,
  TESTNET = 97,
  ETHEREUM_MAINNET = 1,
  POLYGON_TESTNET = 80001,
  POLYGON_MAINNET = 137,
  ARBITRUM_TESTNET = 421613

}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum SmartRouter {
  BABYDOGE = "BABYDOGE",
  PANCAKE = "PANCAKE",
  APE = "APE",
  BISWAP = "BiSwap",
  SUSHISWAP = "SUSHISWAP"
}

export const SMART_INIT_CODE_HASH: Record<number, {
  [SmartRouter.BABYDOGE]: string
  [SmartRouter.PANCAKE]: string
  [SmartRouter.APE]: string
  [SmartRouter.BISWAP]: string
  [SmartRouter.SUSHISWAP]: string
}> = {
  [ChainId.MAINNET]: {
    [SmartRouter.BABYDOGE]: '0x5646bd1da4b93040d09d9a44666ac5ad7d4eb0711841defc40f00dce1aba0b06',
    [SmartRouter.PANCAKE]: '0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5',
    [SmartRouter.APE]: '0xf4ccce374816856d11f00e4069e7cada164065686fbef53c6167a63ec2fd8c5b',
    [SmartRouter.BISWAP]: '0xfea293c909d87cd4153593f077b76bb7e94340200f4ee84211ae8e4f9bd7ffdf',
    [SmartRouter.SUSHISWAP]: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  },
  [ChainId.TESTNET]: {
    [SmartRouter.BABYDOGE]: '0xfddc8bd1082c26d0809ac77a68d86901be4e4b567020336f11f1411f404db7f4',
    [SmartRouter.PANCAKE]: '0xd0d4c4cd0848c93cb4fd1f498d7013ee6bfb25783ea21593d5834f5d250ece66',
    [SmartRouter.APE]: '',
    [SmartRouter.BISWAP]: '',
    [SmartRouter.SUSHISWAP]: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  }
}

export const SMART_FACTORY_ADDRESS: Record<number, {
  [SmartRouter.BABYDOGE]: string
  [SmartRouter.PANCAKE]: string
  [SmartRouter.APE]: string
  [SmartRouter.BISWAP]: string
  [SmartRouter.SUSHISWAP]: string
}> = {
  [ChainId.MAINNET]: {
    [SmartRouter.BABYDOGE]: '0x4693B62E5fc9c0a45F89D62e6300a03C85f43137',
    [SmartRouter.PANCAKE]: '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73',
    [SmartRouter.APE]: '0x0841BD0B734E4F5853f0dD8d7Ea041c241fb0Da6',
    [SmartRouter.BISWAP]: '0x858E3312ed3A876947EA49d572A7C42DE08af7EE',
    [SmartRouter.SUSHISWAP]: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
  },
  [ChainId.TESTNET]: {
    [SmartRouter.BABYDOGE]: '0x22187FDf63883a7A45c2dfCbC88721F4ac95e062',
    [SmartRouter.PANCAKE]: '0x6725f303b657a9451d8ba641348b6761a6cc7a17',
    [SmartRouter.APE]: '',
    [SmartRouter.BISWAP]: '',
    [SmartRouter.SUSHISWAP]: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
  }
}

export const SMART_ROUTER_ADDRESS: Record<number, {
  [SmartRouter.BABYDOGE]: string
  [SmartRouter.PANCAKE]: string
  [SmartRouter.APE]: string
  [SmartRouter.BISWAP]: string
  [SmartRouter.SUSHISWAP]: string
}> = {
  [ChainId.MAINNET]: {
    [SmartRouter.BABYDOGE]: '0xC9a0F685F39d05D835c369036251ee3aEaaF3c47',
    [SmartRouter.PANCAKE]: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
    [SmartRouter.APE]: '0xcf0febd3f17cef5b47b0cd257acf6025c5bff3b7',
    [SmartRouter.BISWAP]: '0x3a6d8cA21D1CF76F653A67577FA0D27453350dD8',
    [SmartRouter.SUSHISWAP]: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
  },
  [ChainId.TESTNET]: {
    [SmartRouter.BABYDOGE]: '0xa18f36819023ABe64a1D811E529f6bc83fEF9572',
    [SmartRouter.PANCAKE]: '0xD99D1c33F9fC3444f8101754aBC46c52416550D1',
    [SmartRouter.APE]: '',
    [SmartRouter.BISWAP]: '',
    [SmartRouter.SUSHISWAP]: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
  }
}

export const BONUS_ROUTER_ADDRESS = {
  [ChainId.MAINNET]: '0x8BCF4f40B993d8361A9c4292d715661BFF976f89'
}


// Wallchain keys
export const WALLCHAIN_API_KEYS = {
  [ChainId.MAINNET]: {
    [SmartRouter.BABYDOGE]: 'c24ad958-f599-43f3-8123-3a1c28011a2a',
    [SmartRouter.PANCAKE]: '7d35c731-cb11-494e-8ff3-532a5c58852c',
    [SmartRouter.APE]: 'ee56282b-c7b3-4498-bfbf-db261f4c749b',
    [SmartRouter.BISWAP]: '2f2fec98-05b1-44f8-9647-66e40bb60e1f',
    [SmartRouter.SUSHISWAP]: '37e8017e-40f0-414d-9bf0-aa757dbb3010',
  },
  // Doesnt exist on testnet as of writing
  [ChainId.TESTNET]: {
    [SmartRouter.BABYDOGE]: '',
    [SmartRouter.PANCAKE]: '',
  },
}

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const NEGATIVE_ONE = JSBI.BigInt(-1)
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const FEES_NUMERATOR = JSBI.BigInt(9975)
export const FEES_DENOMINATOR = JSBI.BigInt(10000)

// used in liquidity amount math
export const Q96 = JSBI.exponentiate(JSBI.BigInt(2), JSBI.BigInt(96))
export const Q192 = JSBI.exponentiate(Q96, JSBI.BigInt(2))

// used in fee calculation
export const MAX_FEE = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(6))
export const ONE_HUNDRED_PERCENT = new Percent('1')
export const ZERO_PERCENT = new Percent('0')
export const Q128 = JSBI.exponentiate(JSBI.BigInt(2), JSBI.BigInt(128))

export const MaxUint256 = JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}

export const WBNB = {
  [ChainId.MAINNET]: new Token(
    ChainId.MAINNET,
    '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    18,
    'WBNB',
    'Wrapped BNB',
    'https://www.binance.org'
  ),
  [ChainId.TESTNET]: new Token(
    ChainId.TESTNET,
    '0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd',
    18,
    'WBNB',
    'Wrapped BNB',
    'https://www.binance.org'
  ),
}

export const WNATIVE: Record<number, Token> = {
  [ChainId.MAINNET]: WBNB[ChainId.MAINNET],
  [ChainId.TESTNET]: WBNB[ChainId.TESTNET],
}

export const NATIVE: Record<
  number,
  {
    name: string
    symbol: string
    decimals: number
  }
> = {
  [ChainId.MAINNET]: {
    name: 'Binance Chain Native Token',
    symbol: 'BNB',
    decimals: 18,
  },
  [ChainId.TESTNET]: {
    name: 'Binance Chain Native Token',
    symbol: 'BNB',
    decimals: 18,
  },
}

// V3 SDK
export const FACTORY_ADDRESS = '0x8fE6241DC5EA20a7a2952F89717fbEF62d575f7a'

export const DEPLOYER_ADDRESS = '0xFF5500f34C09bA9FdE0765602ec35810560ced89'

export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000'

export const POOL_INIT_CODE_HASH = '0xc42d6ebaecdbd19de7c7fb37457e6a703aff834afde918445e48d41b9de432b2'

/**
 * The default factory enabled fee amounts, denominated in hundredths of bips.
 */
export enum FeeAmount {
  LOWEST = 100,
  LOW = 500,
  MEDIUM = 2500,
  HIGH = 10000,
}

/**
 * The default factory tick spacings by fee amount.
 */
export const TICK_SPACINGS: { [amount in FeeAmount]: number } = {
  [FeeAmount.LOWEST]: 1,
  [FeeAmount.LOW]: 10,
  [FeeAmount.MEDIUM]: 50,
  [FeeAmount.HIGH]: 200,
}

export const V3_QUOTER_ADDRESSES = {
  [ChainId.MAINNET]: '',
  [ChainId.TESTNET]: '0xcFa6FCFEBc242449a9E92caa39df140e160b35F1'
}

export const SWAP_ROUTER_ADDRESS = {
  [ChainId.MAINNET]: '',
  [ChainId.TESTNET]: '0x8FbDB7397D7DE3578deBea05cC5bDb4B31bee5c0'
}